import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { FaPlus, FaSearch, FaTimes } from 'react-icons/fa';
import LoadingSubmitButton from '../../../../components/LoadingSubmitButton';
import pencilIcon from '../../../../assets/pencil.png';
import trashIcon from '../../../../assets/trash.png';

const EditIcon = () => <img src={pencilIcon} alt="ערוך" style={{ width: 24, height: 24, objectFit: 'contain' }} />;
const DeleteIcon = () => <img src={trashIcon} alt="מחק" style={{ width: 24, height: 24, objectFit: 'contain' }} />;

const CategoriesTab = ({
  categories,
  editingCategory,
  newCategory,
  setNewCategory,
  handleAddCategory,
  handleEditCategory,
  handleSaveCategory,
  handleDeleteCategory,
  setEditingCategory
}) => {
  const [isAdding, setIsAdding] = useState(false);
  const [editedCategory, setEditedCategory] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [deletingIndex, setDeletingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const startEditing = (index) => {
    setEditedCategory({ ...categories[index] });
    handleEditCategory(index);
    setIsAdding(false);
  };

  const cancelEditing = () => {
    setEditedCategory(null);
    setEditingCategory(null);
    setIsAdding(false);
  };

  const saveEditing = async () => {
    if (editedCategory) {
      setIsSaving(true);
      await handleSaveCategory(editingCategory, editedCategory);
      setIsSaving(false);
      setEditedCategory(null);
    }
  };

  const handleAddCategoryClick = async () => {
    setIsSaving(true);
    const success = await handleAddCategory();
    if (success) {
      setIsAdding(false);
    }
    setIsSaving(false);
  };

  const handleDeleteClick = async (index) => {
    setDeletingIndex(index);
    await handleDeleteCategory(index);
    setDeletingIndex(null);
  };

  const startAdding = () => {
    setIsAdding(true);
    setEditingCategory(null);
    setEditedCategory(null);
    setNewCategory({ name: '', imagePath: '' });
  };

  return (
    <section className="antibiogram-section">
      <div className="tab-description">
        הגדרת קטגוריות רפואיות (כגון דרכי נשימה, שתן וכו'). כל פרוטוקול משויך לקטגוריה אחת.
        הקטגוריות מוצגות למשתמש בשלב הראשון של השאלון.
      </div>

      <div className="drug-search-wrapper">
        <FaSearch className="drug-search-icon" size={16} />
        <input
          className="drug-search-input"
          type="text"
          placeholder="חיפוש קטגוריה"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          dir="rtl"
        />
        <button className="drug-search-clear" onClick={() => setSearchQuery('')} aria-label="נקה חיפוש">
          <FaTimes size={14} />
        </button>
      </div>

      {isAdding && (
        <div className="formula-item editing" style={{ marginBottom: '24px' }}>
          <div className="formula-edit-form">
            <div className="formula-edit-row">
              <span className="formula-edit-label">שם קטגוריה</span>
              <input
                className="formula-edit-input"
                value={newCategory.name}
                onChange={(e) => setNewCategory({ ...newCategory, name: e.target.value })}
                placeholder="שם קטגוריה"
                dir="rtl"
                autoFocus
              />
            </div>
            <div className="formula-edit-row">
              <span className="formula-edit-label">נתיב תמונה</span>
              <input
                className="formula-edit-input"
                value={newCategory.imagePath}
                onChange={(e) => setNewCategory({ ...newCategory, imagePath: e.target.value })}
                placeholder="אייקון: שם FA (למשל faHeadSideMask), SVG, או נתיב תמונה"
                dir="ltr"
              />
            </div>
            <div className="formula-edit-actions">
              <LoadingSubmitButton
                onClick={handleAddCategoryClick}
                isLoading={isSaving}
                disabled={!newCategory.name || !newCategory.imagePath}
                text="הוספה"
                loadingText="מוסיף..."
                style={{ backgroundColor: '#103C6E', borderRadius: '8px', padding: '8px 30px', border: 'none', color: '#fff', cursor: 'pointer', fontFamily: 'inherit', fontWeight: 'bold' }}
              />
              <Button
                variant="outlined"
                onClick={() => {
                  setIsAdding(false);
                  setNewCategory({ name: '', imagePath: '' });
                }}
                disabled={isSaving}
                sx={{ borderColor: '#103C6E', color: '#103C6E', borderRadius: '8px', padding: '8px 30px', marginRight: '12px' }}
              >
                בטל
              </Button>
            </div>
          </div>
        </div>
      )}

      <button className="add-drug-fab" onClick={startAdding} aria-label="הוסף קטגוריה">
        <FaPlus size={20} />
      </button>

      <div className="formula-items-list">
        {categories.map((category, index) => {
          if (searchQuery && !category.name?.toLowerCase().includes(searchQuery.toLowerCase())) return null;
          const isEditing = editingCategory === index;
          return (
            <div key={index} className={`formula-item${isEditing ? ' editing' : ''}`}>
              {isEditing ? (
                <div className="formula-edit-form">
                  <div className="formula-edit-row">
                    <span className="formula-edit-label">שם קטגוריה</span>
                    <input
                      className="formula-edit-input"
                      value={editedCategory?.name || ''}
                      onChange={(e) => setEditedCategory(prev => ({ ...prev, name: e.target.value }))}
                      placeholder="שם קטגוריה"
                      dir="rtl"
                      autoFocus
                    />
                  </div>
                  <div className="formula-edit-row">
                    <span className="formula-edit-label">נתיב תמונה</span>
                    <input
                      className="formula-edit-input"
                      value={editedCategory?.imagePath || ''}
                      onChange={(e) => setEditedCategory(prev => ({ ...prev, imagePath: e.target.value }))}
                      placeholder="אייקון: שם FA (למשל faHeadSideMask), SVG, או נתיב תמונה"
                      dir="ltr"
                    />
                  </div>
                  <div className="formula-edit-actions">
                    <LoadingSubmitButton
                      onClick={saveEditing}
                      isLoading={isSaving}
                      text="שמירת שינויים"
                      loadingText="שומר..."
                      style={{ backgroundColor: '#103C6E', borderRadius: '8px', padding: '8px 30px', border: 'none', color: '#fff', cursor: 'pointer', fontFamily: 'inherit', fontWeight: 'bold' }}
                    />
                    <Button
                      variant="outlined"
                      onClick={cancelEditing}
                      disabled={isSaving}
                      sx={{ borderColor: '#103C6E', color: '#103C6E', borderRadius: '8px', padding: '8px 30px', marginRight: '12px' }}
                    >
                      בטל
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="formula-header">
                  <div className="formula-info">
                    <div className="formula-title">{category.name || ''}</div>
                  </div>
                  <div className="formula-actions">
                    <div className="action-icon edit-icon" onClick={() => startEditing(index)}>
                      <EditIcon />
                    </div>
                    {deletingIndex === index ? (
                      <div className="action-icon style-loader">
                        <CircularProgress size={24} sx={{ color: '#103C6E' }} />
                      </div>
                    ) : (
                      <div className="action-icon delete-icon" onClick={() => handleDeleteClick(index)}>
                        <DeleteIcon />
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default CategoriesTab;
